<script lang="ts">
    import { mdiChevronUp } from "@mdi/js";
    import { Doc } from "sveltefire";
    import {
        Card,
        CardTitle,
        ListGroup,
        Divider,
        List,
        ListItem,
        Icon,
        ProgressCircular,
    } from "svelte-materialify/src";

    let wellActive = false;
    let familiarActive = false;
</script>

<Card outlined>
    <CardTitle class="remove-break">My Languages</CardTitle>
    <Divider />
    <List>
        <Doc
            path={"languages/well"}
            traceId={"languagesWellRead"}
            let:data={wellInfo}
        >
            <ListGroup bind:active={wellActive}>
                <span slot="activator" class="block-wrap remove-break"
                    >Languages I Know Well</span
                >
                <span slot="append">
                    <Icon path={mdiChevronUp} rotate={wellActive ? 0 : 180} />
                </span>
                {#each wellInfo.list.sort() as item, i}
                    <ListItem
                        class="cursor-default remove-break"
                        style="color: var(--theme-text-secondary)"
                        >{item}</ListItem
                    >
                    {#if i + 1 < wellInfo.list.length}
                        <Divider />
                    {/if}
                {/each}
            </ListGroup>
            <span slot="loading">
                <ProgressCircular indeterminate color="primary" /></span
            >
            <span slot="fallback">Error loading data</span>
        </Doc>
        <Doc
            path={"languages/familiar"}
            traceId={"languagesFamiliarRead"}
            let:data={familiarInfo}
        >
            <ListGroup bind:active={familiarActive}>
                <span slot="activator" class="block-wrap remove-break"
                    >Languages I Am Familiar With</span
                >
                <span slot="append">
                    <Icon
                        path={mdiChevronUp}
                        rotate={familiarActive ? 0 : 180}
                    />
                </span>
                {#each familiarInfo.list.sort() as item, i}
                    <ListItem
                        class="cursor-default remove-break"
                        style="color: var(--theme-text-secondary)"
                        >{item}</ListItem
                    >
                    {#if i + 1 < familiarInfo.list.length}
                        <Divider />
                    {/if}
                {/each}
            </ListGroup>
            <span slot="loading">
                <ProgressCircular indeterminate color="primary" /></span
            >
            <span slot="fallback">Error loading data</span>
        </Doc>
    </List>
</Card>
